import type {ReactElement} from 'react';
import {TextAlignmentControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/text-alignment-control/text-alignment-control';
import type {DescriptionAlignmentControlProps} from './description-alignment-control.types';

export function DescriptionAlignmentControl({component}: DescriptionAlignmentControlProps): ReactElement {
  return <TextAlignmentControl component={component} />;
}
